export default class PlayListData {
    constructor(actor) {
        /** @type {OActor} */
        this._actor = actor;
    }

    /**     * @public     */
    setData(data) {
        this._data = data;
        this._currentIndex = 0;
        this._total = this._data.length;
    }

    /**     * @public     */
    startPlay() {
        this._saveLoop = this._actor.loop;
        this._saveSpeed = this._actor.speed;
        this._saveTotalLoop = this._actor.totalLoop;
        this._saveAName = this._actor.aName;
        this._isFinish = false;

        this._play();
    }

    /**     * @public     */
    next() {
        if (!this._isFinish) {
            this._play();
        }
    }

    /**     * @private     */
    _play() {
        let data = this._data[this._currentIndex++];
        this._actor.changeAnimation(data.name);
        this._actor.totalLoop = data.totalLoop;
        this._actor.speed = data.speed;
        this._actor.gotoAndPlay(0, data.loop);
        if (this._currentIndex >= this._total)
            this._isFinish = true;
    }

    /**     * @public     */
    clear() {
        if (this._data) {
            this._data = null;
            this._actor.changeAnimation(this._saveAName);
            this._actor.totalLoop = this._saveTotalLoop;
            this._actor.speed = this._saveSpeed;
            this._actor.loop = this._saveLoop;
            this._actor.stop();
        }
    }

    /**     * @public     */
    destroy() {
        this.clear();
        this._saveAName = null;
        this._actor = null;
    }

    get isFinish() {
        return this._isFinish;
    }

    get id() {
        return this._currentIndex - 1;
    }
}
